var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82485 10.6147V17.1467H0C0 15.4143 0.719044 13.7529 1.99895 12.5279C3.27886 11.3029 5.01479 10.6147 6.82485 10.6147ZM11.9435 16.7385L9.4362 18L9.9148 15.3284L7.88696 13.4357L10.6903 13.0454L11.9435 10.6147L13.1975 13.0454L16 13.4357L13.9722 15.3284L14.4499 18L11.9435 16.7385ZM6.82485 9.79814C3.9968 9.79814 1.70621 7.60581 1.70621 4.89907C1.70621 2.19233 3.9968 0 6.82485 0C9.65289 0 11.9435 2.19233 11.9435 4.89907C11.9435 7.60581 9.65289 9.79814 6.82485 9.79814Z",
    fill: "#A285D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.924e74c5d4797d082f77cf9ebadcc29b.svg";
export { ForwardRef as ReactComponent };